import {CanDeactivateFn} from "@angular/router";

export const unsavedChangesGuard: CanDeactivateFn<any> = (component, currentRoute, currentState, nextState) => {
  return component?.canDeactivate ? component.canDeactivate(nextState) : true;
};
